import React, { useRef } from 'react';
import { Button } from '@material-ui/core';
import { MuiPickersUtilsProvider, KeyboardDateTimePicker } from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';
import moment from 'moment';
import indigo from '@material-ui/core/colors/indigo';
import { createTheme } from '@material-ui/core';
import { ThemeProvider } from '@material-ui/styles';
import PropTypes from 'prop-types';
import trI18n from '@/common/utils/trI18n';

const defaultMaterialTheme = createTheme({
    palette: {
        primary: indigo,
    },
});

DateTimePickerInput.propTypes = {
    value: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
    onChange: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
    messageError: PropTypes.string,
    invalidDateMessage: PropTypes.string,
    onClose: PropTypes.func,
    showCloseButton: PropTypes.bool,
    format: PropTypes.string,
    placeholder: PropTypes.string,
    className: PropTypes.string,
    heightClass: PropTypes.string,
    inputRef: PropTypes.oneOfType([
        PropTypes.func,
        PropTypes.shape({ current: PropTypes.any })
    ]),
    ampm: PropTypes.bool,
    disableOpenPicker: PropTypes.bool,
    allowKeyboardControl: PropTypes.bool,
    InputProps: PropTypes.object,
    hideIcon: PropTypes.bool,
};

DateTimePickerInput.defaultProps = {
    value: null,
    disabled: false,
    messageError: '',
    invalidDateMessage: trI18n('USER07MSG002'),
    onClose: null,
    showCloseButton: false,
    format: 'YYYY/MM/DD HH:mm',
    placeholder: 'YYYY/MM/DD HH:mm',
    className: 'field-date-picker form-control-wrapPicker',
    heightClass: 'form-control-hg32',
    inputRef: null,
    ampm: false,
    disableOpenPicker: false,
    allowKeyboardControl: true,
    InputProps: {
        readOnly: false
    },
    hideIcon: false,
};

function DateTimePickerInput(props) {
    const {
        value,
        onChange,
        disabled,
        messageError,
        invalidDateMessage,
        onClose,
        showCloseButton,
        format,
        placeholder,
        className,
        heightClass,
        inputRef,
        ampm,
        disableOpenPicker,
        allowKeyboardControl,
        InputProps,
        hideIcon,
    } = props;

    const dateTimePickerInputRef = useRef(null);
    const finalInputRef = inputRef || dateTimePickerInputRef;

    // Convert datetime string to moment object for picker
    const getDateTimeValue = () => {
        if (!value) {
            return null;
        }
        if (moment.isMoment(value)) {
            return value;
        }
        if (typeof value === 'string') {
            return moment(value, format, true);
        }
        return value;
    };

    // Merge InputProps with hideIcon logic
    const finalInputProps = hideIcon 
        ? {
            ...InputProps,
            endAdornment: null
        }
        : InputProps;

    return (
        <MuiPickersUtilsProvider utils={MomentUtils}>
            <ThemeProvider theme={defaultMaterialTheme}>
                <div className='itemDatePicker'>
                    <KeyboardDateTimePicker
                        className={`${className} ${heightClass}`}
                        value={getDateTimeValue()}
                        format={format}
                        ampm={ampm}
                        onChange={onChange}
                        disabled={disabled}
                        inputVariant="outlined"
                        placeholder={placeholder}
                        disableOpenPicker={disableOpenPicker}
                        allowKeyboardControl={allowKeyboardControl}
                        inputRef={finalInputRef}
                        invalidDateMessage={invalidDateMessage}
                        error={messageError !== ''}
                        helperText={messageError !== '' ? messageError : ''}
                        InputProps={finalInputProps}
                        keyboardIcon={hideIcon ? null : undefined}
                    />
                    {showCloseButton && !disabled && onClose && (
                        <Button 
                            disabled={disabled} 
                            className='close-DatePicker' 
                            onClick={onClose}
                        >
                            <img src="/assets/image/icon-close-datetime.svg" alt="" />
                        </Button>
                    )}
                </div>
            </ThemeProvider>
        </MuiPickersUtilsProvider>
    );
}

export default DateTimePickerInput;

